import { render } from "./StoreActivityPanel.vue?vue&type=template&id=bcd73488&scoped=true&lang=pug"
import script from "./StoreActivityPanel.vue?vue&type=script&lang=js"
export * from "./StoreActivityPanel.vue?vue&type=script&lang=js"

import "./StoreActivityPanel.vue?vue&type=style&index=0&id=bcd73488&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcd73488"]])

export default __exports__